import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /** Disables the filter's interactive controls. */
  disabled: booleanAttribute(),
  modelValue: {
    type: [String, Number, Boolean, Object, Array],
    default: undefined,
  },
  /**
   * The form element name of the component.
   */
  name: {
    type: String,
    default: "app-filter",
  },
  /**
   * The label of the activator.
   *
   * @type {String}
   */
  label: {
    type: String,
    default: "Insurance",
  },
  /**
   * The icon to prepend to the activator.
   *
   * @type {String}
   */
  prependIcon: {
    type: String,
    default: "insurance-carrier-filled",
  },
  /**
   * The icon to append to the activator.
   *
   * @type {String}
   */
  appendIcon: {
    type: String,
    default: "popup-arrow-filled",
  },
  /**
   * Hide the progress bar.
   *
   * @type {Boolean|String}
   * @default false
   */
  hideProgressBar: booleanAttribute(),
  /**
   * Hide the search bar.
   *
   * @type {Boolean|String}
   * @default false
   */
  hideSearchBar: booleanAttribute(),
  /**
   * Hide the title bar.
   *
   * @type {Boolean|String}
   * @default false
   */
  hideTitleBar: booleanAttribute(),
  /**
   * The endpoint the plan list is loaded from.
   *
   * @context api
   */
  url: {
    type: String,
    default: undefined,
  },
  hidePointer: {
    type: Boolean,
    default: false,
  },
  open: {
    type: Boolean,
    default: false,
  },
  location: {
    type: String,
    default: undefined,
  },
  inline: {
    type: Boolean,
    default: false,
  },
  closeOnSelect: {
    type: Boolean,
    default: false,
  },
  permanent: booleanAttribute(),
  maxHeight: {
    type: String,
    default: undefined,
  },
  readonly: booleanAttribute(),
  /** Requires an insurance plan before form submission. @type {Boolean|String} */
  required: booleanAttribute(),
  startOnRoot: booleanAttribute(),
  /**
   * When set, the filter hides its clear affordances so the selected plan can
   * never be emptied. Used for legally required filters.
   */
  nonClearable: booleanAttribute(),
});
